<template>
  <div :class="{'content-wrapper':remove == false}">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="title"
          :directory="$t('datatables')"
          :icon="'grid'"
        />
      </div>
      <div class="col-sm-12 col-md-6 breadcrumb-side-button">
        <div class="float-md-right mb-3 mb-sm-3 mb-md-0">
          <button
            v-if="isBackToimport"
            type="button"
            class="btn btn-primary btn-sm"
            data-toggle="modal"
            @click="backToimport">
            Back To List
          </button>
          <el-tooltip
            placement="top"
            :effect="theemMode.darkMode == true ? 'light' : 'dark'"
            :content="$t('instruction')">
             <button
              type="button"
              class="btn btn-primary btn-sm"
              data-toggle="modal"
              @click="instructionOpen">
              <!-- {{ $t("instruction") }} -->
              <app-icon name="book-open" />
            </button>

          </el-tooltip>
        </div>
      </div>
      <div class="col-sm-12 col-md-12 col-lg-12 mb-2" v-if="instructionShow == true">
        <div class="alert alert-info" role="alert">
          <button type="button" class="close" @click.prevent="instructionClose">
            <h5 aria-hidden="true">&times;</h5>
          </button>
          <!-- <hr> -->
          <h5 class="alert-heading"><app-icon name="book-open" /> {{title == 'Questionnaire' ? $t("instructions_about_questionnaire") : $t("instructions_about_document_library") }}</h5>
          <p class="mb-0">{{title == 'Questionnaire' ? $t("introduction_questionnaire") : $t("introduction_document_library")}}</p>
          <strong>Actions:</strong>
          <ul>
            <li><strong>{{ $t("form_builder") }} :</strong> {{ $t("form_builder_view_action") }}</li>

          </ul>
        </div>
      </div>
    </div>
    <el-form v-if="active === 1">
      <div class="card card-folders">
          <div class="card-header">
            <div class="row align-items-center">
                <div class="col mr-auto">
                  <h4 class="card-title m-0">User Folders</h4>
                </div>
                <!-- <div class="col col-auto pr-2">
                  <div class="btn-group">
                    <button class="btn btn-sm btn-outline-secondary" id="btn-list" @click.prevent="list"><i class="fa fa-th-list fa-lg"></i></button>
                    <button class="btn btn-sm btn-outline-secondary outline-none active" id="btn-grid" @click.prevent="grid"><i class="fa fa-th-large fa-lg"></i></button>
                  </div>
                </div> -->
              </div>
          </div>
          <div class="card-body" id="foldersGroup">
            <!-- <ol class="breadcrumb">
              <li class="breadcrumb-item active"><i class="far fa-folder"></i>&nbsp; Folders</li>
            </ol> -->
            <div id="main-folders" class="d-flex align-items-stretch flex-wrap flex-column">
              <div class="d-inline-flex">
                <tree-menu 
                  :label="tree.label" 
                  :nodes="tree.nodes"
                  :category_name="tree.nodes.category_name"
                  :depth="0"
                  :owner_id="tree.nodes.owner_id"
                  :form_id="tree.nodes.id"
                  :type="type"
                  :myForm="myForm"
                  :refresh="loadDocuments"
                  :sendToChield="receivedFromSubChild"
                  :importFlag="importFlag"
                  :updated_at="tree.nodes.updated_at"
                  :expanded="true"
                      >
                </tree-menu>
              </div>
            </div>
          </div>
      </div>
    </el-form>

    <el-form v-if="active === 2">
      <documentlibrary-add-forminformation @view="view" :back="backToimport" :type="type" :useTemplateData="useTemplateData" :isUseTemplate="true"></documentlibrary-add-forminformation>
    </el-form>

    <app-formBuilder-modal
      v-if="formBuilderModalActive"
      :id="id"
      :useTemplateId="useTemplateId"
      :isUseTemplate="isUseTemplate"
      :type="type"
      :myForm="myForm"
      :table-id="tableId"
      @close-modal="FormBuilderModalClose"
    />
  </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary.js";
import * as actions from "../../../../Config/ApiUrl";
import {TableHelpers} from "../../Demo/Tables/mixins/TableHelpers";
import TreeMenu from './TreeMenu.vue'
import {createListTree, unflatten} from "@Views/CustomFormBuilder/utilities/formsDirectory";

export default {
  extends: CoreLibrary,
  name: "DocumentLibrary",
  mixins: [TableHelpers],
  components: {
    TreeMenu
  },
  props: {
    remove: Boolean,
    importFlag: {
      type: Boolean,
      default: false,
    },
    is_use_template: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tree : {
        label: 'Click to Expand',
        nodes: [],
        expanded: true
      },
      active: 1,
      isBackToimport: false,
      tableId:'form-revision-table',
      formUrl: '',
      instructionShow: false,
      type:'',
      title:'',
      id: 0,
      myForm: '',
      children: [],
      documents: [],
      parentEl:[],
      childEl: [],
      formBuilderModalActive: false,
      useTemplateData: {},
      useTemplateId: 0,
      isUseTemplate: false,
    };
  },
  methods: {
    receivedFromSubChild(formId, activeValue) {

      this.axiosGet(actions.FORM_GET_EDIT+'/'+formId)
        .then((res) => {
          this.useTemplateData = res.data;
          this.isBackToimport = true;
          this.title = 'Use Template';
          this.active = activeValue;
        })
        .catch((error) => {
          
        });
    },
    view(formId, useTemplateId, isUseTemplate) {
        this.id = formId;
        this.useTemplateId = useTemplateId;
        this.isUseTemplate = isUseTemplate;
        this.openFormBuilderModal();
    },
    openFormBuilderModal() {
      this.formBuilderModalActive = true;
    },
    FormBuilderModalClose() {
      this.backToimport();
      $("#form-builder-Modal").modal("hide");
      this.formBuilderModalActive = false;
    },
    instructionOpen() {
      this.instructionShow = true;
    },
    instructionClose() {
      this.instructionShow = false;
    },
    
    openAddEditModal() {
      this.isAddEditModalActive = true;
    },
    closeFormBuilderModal(){
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
    },

    closeAddEditModal() {
      $("#demo-add-edit-Modal").modal("hide");
      this.isAddEditModalActive = false;
      // this.searchAndSelectFilterOptions();
      this.reSetData();
    },

    setFormType()
    {
      let myLocation = location.href;
      let split = myLocation.split("/");
      let type = split[5].split("?")[0];

      let isUseTemplate = this.is_use_template ? 'isUseTemplate=true' : '';
      
      if (type == 'questionnaire' || type == 'myquestionnaire' || type == 'mytraining') {
        let form_type = type == 'mytraining' ? 'training' : 'questionnaire';
        this.formUrl = actions.FORMS_GET+'?form_type='+form_type+'&'+isUseTemplate;
        this.title = this.$t(type == 'mytraining' ? 'training_modules' : 'questionnaire');
        this.type = type;
      }
      else
      {
        this.formUrl = actions.FORMS_GET+'?'+isUseTemplate;
        this.title =  this.$t('documentlibrary');
      }
    },
    backToimport() {
      this.active = 1;
      this.isBackToimport = false;
      this.setFormType();
    },
    loadDocuments() {
      var document_url = this.formUrl;
      this.axiosGet(document_url)
        .then((res) => {
            // this.children = res.data;
             this.preloader = false;
            // console.log("response documents", res.data);
           this.parentEl = res.data.filter( da => {
               return da.parent_id == null;
            })
            this.childEl = res.data.filter( da => {
               return da.parent_id !== null;
            })


            // console.log("filterData", this.parentEl)

            this.parentEl = this.parentEl.map(pa => {
              return  {
                form_id: pa.id,
                label: pa.name,
                owner_id: pa.owner_id,
                is_file_folder: pa.is_file_folder,
                category_name: pa.form_category ? pa.form_category.title : '', //Without Category
                updated_at: moment(pa.updated_at).format('YYYY-MM-DD'),

                // children:[]
              }
            }),

              this.children = res.data.map(pa => {
              return  {
                id: pa.id,
                label: pa.name,
                owner_id: pa.owner_id,
                is_file_folder: pa.is_file_folder,
                parent_id: pa.parent_id,
                category_name: pa.form_category ? pa.form_category.title : '', //Without Category
                updated_at: moment(pa.updated_at).format('YYYY-MM-DD'),
                nodes:null
              }
            }),

            //  this.tree = {...this.tree, nodes : this.children};
            //  console.log("tree", this.tree);
              this.openSubList();
            //  console.log("parent element", this.parentEl);
             this.documents = this.parentEl;
          //  console.log("parent element", this.documents);
            // this.links = res.data.links;
            // this.next_page_url = res.next_page_url;
            // this.prev_page_url = res.prev_page_url;

        })
        .catch((res) => {

        })
        .finally(() => {
        });
    },
    openSubList(id){

      let data = this.unflatten(this.children)
      this.tree = {...this.tree, nodes : data};
      // console.log('data',data);
    },


    unflatten(arr) {
      var tree = [],
          mappedArr = {},
          arrElem,
          mappedElem;

      // console.log('array',arr);
      // First map the nodes of the array to an object -> create a hash table.
      for(var i = 0, len = arr.length; i < len; i++) {
        arrElem = arr[i];
        mappedArr[arrElem.id] = arrElem;
        mappedArr[arrElem.id]['nodes'] = [];
      }


      try {
        for (var id in mappedArr) {
          if (mappedArr.hasOwnProperty(id)) {
            mappedElem = mappedArr[id];
            // If the element is not at the root level, add it to its parent array of children.
            if (mappedElem.parent_id) {
              mappedArr[mappedElem['parent_id']] && mappedArr[mappedElem['parent_id']]['nodes'].push(mappedElem);
            }
            // If the element is at the root level, add it to first level elements array.
            else {
              mappedElem && tree.push(mappedElem);
            }
          }
        }
        // Create an Intl.Collator instance for locale-sensitive string comparison
        const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

        // Sort each level of the tree by label
        function sortTree(nodes) {

          nodes.sort((a, b) => collator.compare(a.label, b.label));
          nodes.forEach(node => {
            if (node.is_file_folder === 'folder') {
              node.label += ` (${node.nodes.length})`;
            }
            if (node.nodes && node.nodes.length > 0) {
              node.nodes = sortTree(node.nodes);
            }
          });
          return nodes;
        }

        // Apply sorting to the tree nodes
        tree = sortTree(tree);

      } catch (e) {

      }
      return tree;
    },
    createListTree(data02){
       this.childEl =  this.childEl.map(res => {
                return data02.map(res02 => {
                  return res02.filter(data => {
                    return data.parent_id == res.form_id;
                  });
                })
        })
        // console.log("data03 ==>", data03)
    },
    // list() {
    //     $('#main-folders').addClass('flex-column');
    //     $('#btn-grid').removeClass('active')
    //     $(this).addClass('active')
    //   },
      // grid() {
      //   $('#main-folders').removeClass('flex-column');
      //   $('#btn-list').removeClass('active')
      //   $(this).addClass('active')
      // },
  },
  mounted() {
    this.setFormType();
    this.loadDocuments();
    // this.list();
  },
  computed: {
    userRole() {
      return this.$store.state.user.loggedInUser;
    },
    theemMode() {
      return this.$store.state.theme;
    },
  }
};
</script>
<style>

.card01{
  /* box-shadow:10px 10px 5px -6px rgba(8,96,95,0.75) !important; */
  background-color:#292F4C;
  height:200px;
  border-radius: 25px;
  margin: 10px;
}
.icon{
  align-self: center;
  color:#fff;
}
.courser-style {
  cursor: pointer;
}
.div-table {

}
.div-table-head{
  font-weight: 600;
}
.div-table-row {
  display: flex;
  justify-content: space-between;
  width: auto;
  clear: both;
  cursor: pointer;
  padding:  5px;
}
.div-table-row:hover {
  background-color: #efefef;
}
.div-table-col {
  float: left; /* fix for  buggy browsers */
  display: table-column;         
  width: 200px;         
  height: 30px;
}
.children{
  margin-left: 30px;
}
.action-col{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>
